import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
	{
		path: "/track-report",
		component: () =>
			import(
        /* webpackChunkName: "track-report" */ "../views/open/TrackReport.vue"
			),
	},
	{
		path: "/print-xray-report",
		component: () =>
			import(
        /* webpackChunkName: "print-xray-report" */ "../views/open/PrintXrayReport.vue"
			),
	},
	{
		path: "/print-ecg-report",
		component: () =>
			import(
        /* webpackChunkName: "print-ecg-report" */ "../views/open/PrintECGReport.vue"
			),
	},
	{
		path: "/print-pft-report",
		component: () =>
			import(
        /* webpackChunkName: "print-pft-report" */ "../views/open/PrintPFTReport.vue"
			),
	},
	{
		path: "/print-eeg-report",
		component: () =>
			import(
        /* webpackChunkName: "print-eeg-report" */ "../views/open/PrintEEGReport.vue"
			),
	},
	{
		path: "/print-usg-report",
		component: () =>
			import(
        /* webpackChunkName: "print-usg-report" */ "../views/open/PrintUSGReport.vue"
			),
	},
	{
		path: "/print-payment-receipt/:id",
		component: () =>
			import(
        /* webpackChunkName: "print-payment-receipt" */ "../views/open/PrintPaymentReceipt.vue"
			),
	},
	{
		path: "/print-postpaid-payment-voucher/:id",
		component: () =>
			import(
        /* webpackChunkName: "print-postpaid-payment-voucher" */ "../views/open/PrintPostpaidPaymentVoucher.vue"
			),
	},
	{
		path: "/",
		component: Home,
		children: [
			{
				path: "about",
				component: () =>
					import(/* webpackChunkName: "aboutme" */ "../views/About.vue"),
			},
			{
				path: "table",
				component: () =>
					import(/* webpackChunkName: "table" */ "../views/Table.vue"),
			},
		],
	},
	{
		path: "/logins",
		component: () => import(/* webpackChunkName: "logins" */ "../views/Logins.vue"),
	},
	{
		path: "/doctors",
		component: () => import(/* webpackChunkName: "logins" */ "../views/Logins.vue"),
		props: { portalType: "doctor" },
		meta: { title: "Teleradio : Doctor Login" },
	},
	{
		path: "/agents",
		component: () => import(/* webpackChunkName: "logins" */ "../views/Logins.vue"),
		props: { portalType: "agent" },
		meta: { title: "Teleradio : Agent Login" },
	},
	{
		path: "/mobile",
		component: () => import(/* webpackChunkName: "mobile-root" */ "../views/mobile/MobileRoot.vue"),
		children: [
			{ path: "", redirect: "/mobile/login" },
			{ path: "login", component: () => import(/* webpackChunkName: "mobile-login" */ "../views/mobile/MobileLogin.vue"), meta: { title: "TeleRadio : Login" } },
			{
				path: "",
				component: () => import(/* webpackChunkName: "mobile-shell" */ "../views/mobile/AppHome.vue"),
				children: [
					{ path: "dashboard", component: () => import("../views/mobile/Dashboard.vue"), meta: { title: "TeleRadio : Dashboard" } },
					{ path: "settings", component: () => import("../views/mobile/Settings.vue"), meta: { title: "TeleRadio : Settings" } },
					{ path: "notifications", component: () => import("../views/mobile/Notifications.vue"), meta: { title: "TeleRadio : Notifications" } },
					{ path: "profile", component: () => import("../views/mobile/Profile.vue"), meta: { title: "TeleRadio : Profile" } },
					{ path: "profile/update", component: () => import("../views/mobile/GeneralSettings.vue"), meta: { title: "TeleRadio : Update Profile" } },
					{ path: "rate-chart", component: () => import("../views/mobile/RateChart.vue"), meta: { title: "TeleRadio : Rate Chart" } },
					{ path: "payments", component: () => import("../views/mobile/Payment.vue"), meta: { title: "TeleRadio : Payment" } },
					{ path: "payments/add", component: () => import("../views/mobile/Payment.vue"), meta: { title: "TeleRadio : Add Payment" } },
					{ path: "prefer-doctors", component: () => import("../views/mobile/PreferDoctors.vue"), meta: { title: "TeleRadio : Prefer Doctors" } },
					{ path: "prefer-doctors/radiologists", component: () => import("../views/mobile/PreferredRadiologists.vue"), meta: { title: "TeleRadio : Prefer Doctors" } },
					{ path: "prefer-doctors/cardiologists", component: () => import("../views/mobile/PreferredCardiologists.vue"), meta: { title: "TeleRadio : Prefer Doctors" } },
					{ path: "prefer-doctors/neurologists", component: () => import("../views/mobile/PreferredNeurologists.vue"), meta: { title: "TeleRadio : Prefer Doctors" } },
					{ path: "prefer-doctors/pulmonologists", component: () => import("../views/mobile/PreferredPulmonologists.vue"), meta: { title: "TeleRadio : Prefer Doctors" } },
					{ path: "billings/xray-billing", component: () => import("../views/mobile/XrayBilling.vue"), meta: { title: "TeleRadio : X-Ray Billing" } },
					{ path: "billings/xray-billings", component: () => import("../views/mobile/XrayBilling.vue"), meta: { title: "TeleRadio : X-Ray Billings" } },
					{ path: "billings/ecg-billing", component: () => import("../views/mobile/EcgBilling.vue"), meta: { title: "TeleRadio : ECG Billing" } },
					{ path: "billings/ecg-billings", component: () => import("../views/mobile/EcgBilling.vue"), meta: { title: "TeleRadio : ECG Billings" } },
					{ path: "billings/eeg-billing", component: () => import("../views/mobile/EegBilling.vue"), meta: { title: "TeleRadio : EEG Billing" } },
					{ path: "billings/eeg-billings", component: () => import("../views/mobile/EegBilling.vue"), meta: { title: "TeleRadio : EEG Billings" } },
					{ path: "billings/pft-billing", component: () => import("../views/mobile/PftBilling.vue"), meta: { title: "TeleRadio : PFT Billing" } },
					{ path: "billings/pft-billings", component: () => import("../views/mobile/PftBilling.vue"), meta: { title: "TeleRadio : PFT Billings" } },
					{ path: "reports/xray", component: () => import("../views/mobile/RadiologyReporting.vue"), meta: { title: "TeleRadio : Xray Reports" } },
					{ path: "reports/xray/add", component: () => import("../views/mobile/AddRadiologyCase.vue"), meta: { title: "TeleRadio : Add Xray Reports" } },
					{ path: "reports/xray/edit/:id", component: () => import("../views/mobile/AddRadiologyCase.vue"), meta: { title: "TeleRadio : Edit Xray Reports" } },
					{ path: "reports/xray/:id", component: () => import("../views/mobile/CaseDetails.vue"), meta: { modality: "xray", title: "TeleRadio : View Xray Reports" } },
					{ path: "reports/ecg", component: () => import("../views/mobile/CardiologyReporting.vue"), meta: { title: "TeleRadio : ECG Reports" } },
					{ path: "reports/ecg/add", component: () => import("../views/mobile/AddEcgCase.vue"), meta: { title: "TeleRadio : Add ECG Reports" } },
					{ path: "reports/ecg/edit/:id", component: () => import("../views/mobile/AddEcgCase.vue"), meta: { title: "TeleRadio : Edit ECG Reports" } },
					{ path: "reports/ecg/:id", component: () => import("../views/mobile/CaseDetails.vue"), meta: { modality: "ecg", title: "TeleRadio : View ECG Reports" } },
					{ path: "reports/eeg", component: () => import("../views/mobile/NeurologyReporting.vue"), meta: { title: "TeleRadio : EEG Reports" } },
					{ path: "reports/eeg/add", component: () => import("../views/mobile/AddEegCase.vue"), meta: { title: "TeleRadio : Add EEG Reports" } },
					{ path: "reports/eeg/edit/:id", component: () => import("../views/mobile/AddEegCase.vue"), meta: { title: "TeleRadio : Edit EEG Reports" } },
					{ path: "reports/eeg/:id", component: () => import("../views/mobile/CaseDetails.vue"), meta: { modality: "eeg", title: "TeleRadio : View EEG Reports" } },
					{ path: "reports/pft", component: () => import("../views/mobile/PulmonologyReporting.vue"), meta: { title: "TeleRadio : PFT Reports" } },
					{ path: "reports/pft/add", component: () => import("../views/mobile/AddPftCase.vue"), meta: { title: "TeleRadio : Add PFT Reports" } },
					{ path: "reports/pft/edit/:id", component: () => import("../views/mobile/AddPftCase.vue"), meta: { title: "TeleRadio : Edit PFT Reports" } },
					{ path: "reports/pft/:id", component: () => import("../views/mobile/CaseDetails.vue"), meta: { modality: "pft", title: "TeleRadio : View PFT Reports" } },
					{ path: "support", component: () => import("../views/mobile/SupportTickets.vue"), meta: { title: "TeleRadio : Support" } },
					{ path: "support/add", component: () => import("../views/mobile/SupportTickets.vue"), meta: { title: "TeleRadio : Add Ticket" } },
					{ path: "support/:id", component: () => import("../views/mobile/SupportTickets.vue"), meta: { title: "TeleRadio : View Ticket" } },
				],
			},
			{ path: ":pathMatch(.*)*", redirect: "/mobile/login" },
		],
	},
	// admin
	{
		path: "/admin",
		component: () =>
			import(
        /* webpackChunkName: "adminHome" */ "../views/admin/AdminHome.vue"
			),
		redirect: "/admin/dashboard",
		children: [
			{
				path: "dashboard",
				component: () =>
					import(
            /* webpackChunkName: "admin-dashboard" */ "../views/admin/Dashboard.vue"
					),
			},
			{
				path: "center",
				component: () =>
					import(
            /* webpackChunkName: "admin-center" */ "../views/admin/Center.vue"
					),
			},
			{
				path: "center/payment/:id",
				component: () =>
					import(
            /* webpackChunkName: "admin-center-payment" */ "../views/admin/CenterPayment.vue"
					),
			},
			{
				path: "radiologist",
				component: () =>
					import(
            /* webpackChunkName: "admin-radiologist" */ "../views/admin/Radiologist.vue"
					),
			},
				{
				path: "radiologist-rating",
				component: () =>
					import(
            /* webpackChunkName: "admin-radiologist" */ "../views/admin/Radiologist_rating.vue"
					),
			},
			{
				path: "radiologist/payment/:id",
				component: () =>
					import(
            /* webpackChunkName: "admin-radiologist-payment" */ "../views/admin/RadiologistPayment.vue"
					),
			},
			{
				path: "cardiologist",
				component: () =>
					import(
            /* webpackChunkName: "admin-cardiologist" */ "../views/admin/Cardiologist.vue"
					),
			},
			{
				path: "cardiologist/payment/:id",
				component: () =>
					import(
            /* webpackChunkName: "admin-cardiologist-payment" */ "../views/admin/CardiologistPayment.vue"
					),
			},
			{
				path: "pulmonologist",
				component: () =>
					import(
            /* webpackChunkName: "admin-pulmonologist" */ "../views/admin/Pulmonologist.vue"
					),
			},
			{
				path: "pulmonologist/payment/:id",
				component: () =>
					import(
            /* webpackChunkName: "admin-pulmonologist-payment" */ "../views/admin/PulmonologistPayment.vue"
					),
			},
			{
				path: "neurologist",
				component: () =>
					import(
            /* webpackChunkName: "admin-neurologist" */ "../views/admin/Neurologist.vue"
					),
			},
			{
				path: "neurologist/payment/:id",
				component: () =>
					import(
            /* webpackChunkName: "admin-neurologist-payment" */ "../views/admin/NeurologistPayment.vue"
					),
			},
			{
				path: "xray-test",
				component: () =>
					import(
            /* webpackChunkName: "admin-xray-test" */ "../views/admin/XrayTest.vue"
					),
			},
			{
				path: "eeg-test",
				component: () =>
					import(
            /* webpackChunkName: "admin-eeg-test" */ "../views/admin/EEGTest.vue"
					),
			},
			{
				path: "usg-test",
				component: () =>
					import(
            /* webpackChunkName: "admin-usg-test" */ "../views/admin/USGTest.vue"
					),
			},
			{
				path: "agent",
				component: () =>
					import(
            /* webpackChunkName: "admin-agent" */ "../views/admin/Agent.vue"
					),
			},
			{
				path: "agent/payment/:id",
				component: () =>
					import(
            /* webpackChunkName: "admin-agent-payment" */ "../views/admin/AgentPayment.vue"
					),
			},
			{
				path: "xray-reporting",
				component: () =>
					import(
            /* webpackChunkName: "admin-xray-reporting" */ "../views/admin/XRayReporting.vue"
					),
			},
			{
				path: "usg-reporting",
				component: () =>
					import(
			/* webpackChunkName: "admin-usg-reporting" */ "../views/admin/USGReporting.vue"
					),
			},
			{
				path: "ecg-reporting",
				component: () =>
					import(
            /* webpackChunkName: "admin-ecg-reporting" */ "../views/admin/ECGReporting.vue"
					),
			},
			{
				path: "pft-reporting",
				component: () =>
					import(
            /* webpackChunkName: "admin-pft-reporting" */ "../views/admin/PFTReporting.vue"
					),
			},
			{
				path: "eeg-reporting",
				component: () =>
					import(
            /* webpackChunkName: "admin-eeg-reporting" */ "../views/admin/EEGReporting.vue"
					),
			},
			{
				path: "received",
				component: () =>
					import(
            /* webpackChunkName: "admin-received" */ "../views/admin/Received.vue"
					),
			},
			{
				path: "all-radiologist-payment",
				component: () =>
					import(
            /* webpackChunkName: "admin-all-radiologist-payment" */ "../views/admin/AllRadiologistPayment.vue"
					),
			},
			{
				path: "all-cardiologist-payment",
				component: () =>
					import(
            /* webpackChunkName: "admin-all-cardiologist-payment" */ "../views/admin/AllCardiologistPayment.vue"
					),
			},
			{
				path: "all-pulmonologist-payment",
				component: () =>
					import(
            /* webpackChunkName: "admin-all-pulmonologist-payment" */ "../views/admin/AllPulmonologistPayment.vue"
					),
			},
			{
				path: "all-neurologist-payment",
				component: () =>
					import(
            /* webpackChunkName: "admin-all-neurologist-payment" */ "../views/admin/AllNeurologistPayment.vue"
					),
			},
			{
				path: "xray-uploading",
				component: () =>
					import(
            /* webpackChunkName: "admin-xray-uploading" */ "../views/admin/XRayUploading.vue"
					),
			},
			{
				path: "ecg-uploading",
				component: () =>
					import(
            /* webpackChunkName: "admin-ecg-uploading" */ "../views/admin/ECGUploading.vue"
					),
			},
			{
				path: "pft-uploading",
				component: () =>
					import(
            /* webpackChunkName: "admin-pft-uploading" */ "../views/admin/PFTUploading.vue"
					),
			},
			{
				path: "eeg-uploading",
				component: () =>
					import(
            /* webpackChunkName: "admin-eeg-uploading" */ "../views/admin/EEGUploading.vue"
					),
			},
			{
				path: "xray-trend",
				component: () => import(/* webpackChunkName: "admin-xray-trend" */ "../views/admin/XRayTrend.vue"),
			},
			{
				path: "ecg-trend",
				component: () =>
					import(/* webpackChunkName: "admin-ecg-trend" */ "../views/admin/ECGTrend.vue"),
			},
			{
				path: "agent-trend",
				component: () => import(/* webpackChunkName: "admin-agent-trend" */ "../views/admin/AgentTrend.vue"),
			},
			{
				path: "transaction-audit",
				component: () =>
					import(
            /* webpackChunkName: "admin-transaction-audit" */ "../views/admin/TransactionAudit.vue"
					),
			},

			{
				path: "xray-overview",
				component: () =>
					import(
            /* webpackChunkName: "admin-xray-overview" */ "../views/admin/XrayOverview.vue"
					),
			},
			{
				path: "ecg-overview",
				component: () =>
					import(
            /* webpackChunkName: "admin-ecg-overview" */ "../views/admin/ECGOverview.vue"
					),
			},

			{
				path: "yearly-report",
				component: () =>
					import(
            /* webpackChunkName: "admin-yearly-report" */ "../views/admin/YearlyReport.vue"
					),
			},
			{
				path: "recharge-yearly-report",
				component: () =>
					import(
            /* webpackChunkName: "admin-recharge-yearly-report" */ "../views/admin/RechargeYearlyReport.vue"
					),
			},
			{
				path: "new-center-report",
				component: () =>
					import(
            /* webpackChunkName: "admin-new-center-report" */ "../views/admin/NewCenter.vue"
					),
			},
			{
				path: "doctor-report",
				component: () =>
					import(
            /* webpackChunkName: "admin-doctor-report" */ "../views/admin/DoctorReport.vue"
					),
			},
			{
				path: "business-volume",
				component: () =>
					import(
            /* webpackChunkName: "admin-business-volume" */ "../views/admin/BusinessVolume.vue"
					),
			},
			{
				path: "xray-average-range",
				component: () =>
					import(
            /* webpackChunkName: "admin-xray-average-range" */ "../views/admin/XRayAverageRange.vue"
					),
			},

			{
				path: "payment-overview",
				component: () =>
					import(
            /* webpackChunkName: "admin-payment-overview" */ "../views/admin/PaymentOverview.vue"
					),
			},
			{
				path: "postpaid-center-received",
				component: () =>
					import(
            /* webpackChunkName: "admin-postpaid-center-received" */ "../views/admin/PostpaidCenterReceived.vue"
					),
			},

			{
				path: "default-rates",
				component: () =>
					import(
            /* webpackChunkName: "admin-default-rates" */ "../views/admin/DefaultRates.vue"
					),
			},
			{
				path: "notice",
				component: () =>
					import(
            /* webpackChunkName: "admin-notice" */ "../views/admin/Notice.vue"
					),
			},
			{
				path: "dashboard-offer",
				component: () =>
					import(
            /* webpackChunkName: "admin-dashboard-offer" */ "../views/admin/DashboardOffer.vue"
					),
			},
			{
				path: "offer-master",
				component: () =>
					import(
            /* webpackChunkName: "admin-offer-master" */ "../views/admin/OfferMaster.vue"
					),
			},
			{
				path: "reviews",
				component: () =>
					import(
            /* webpackChunkName: "admin-reviews" */ "../views/admin/Review.vue"
					),
			},
			{
				path: "options",
				component: () =>
					import(
            /* webpackChunkName: "admin-options" */ "../views/admin/Options.vue"
					),
			},
		],
	},
	// center
	{
		path: "/center",
		component: () =>
			import(
        /* webpackChunkName: "centerHome" */ "../views/center/CenterHome.vue"
			),
		redirect: "/center/dashboard",
		children: [
			{
				path: "dashboard",
				component: () =>
					import(
            /* webpackChunkName: "center-dashboard" */ "../views/center/Dashboard.vue"
					),
			},

			{
				path: "add-patient",
				component: () =>
					import(
            /* webpackChunkName: "center-add-patient" */ "../views/center/AddPatient.vue"
					),
			},
			{
				path: "complain",
				component: () =>
					import(
            /* webpackChunkName: "center-manage-tickets" */ "../views/center/Complain.vue"
					),
			},
			{
				path: "manage-tickets",
				component: () =>
					import(
            /* webpackChunkName: "center-manage-tickets" */ "../views/center/ManageTickets.vue"
					),
			},
			{
				path: "xray-report",
				component: () =>
					import(
            /* webpackChunkName: "center-xray-report" */ "../views/center/XrayReport.vue"
					),
			},
			{
				path: "xray-report/merged",
				component: () =>
					import(
            /* webpackChunkName: "center-merged-xray-report" */ "../views/center/MergedXrayReport.vue"
					),
			},
			{
				path: "usg-report",
				component: () =>
					import(
            /* webpackChunkName: "center-usg-report" */ "../views/center/USGReport.vue"
					),
			},
			{
				path: "usg-templates",
				component: () =>
					import(
            /* webpackChunkName: "center-usg-templates" */ "../views/center/USGTemplates.vue"
					),
			},
			{
				path: "print-xray-report/:reportId",
				component: () =>
					import(
            /* webpackChunkName: "center-print-xray-report" */ "../views/center/PrintXrayReport.vue"
					),
			},
			{
				path: "ecg-report",
				component: () =>
					import(
            /* webpackChunkName: "center-ecg-report" */ "../views/center/ECGReport.vue"
					),
			},
			{
				path: "print-ecg-report/:reportId",
				component: () =>
					import(
            /* webpackChunkName: "center-print-ecg-report" */ "../views/center/PrintECGReport.vue"
					),
			},
			{
				path: "pft-report",
				component: () =>
					import(
            /* webpackChunkName: "center-pft-report" */ "../views/center/PFTReport.vue"
					),
			},
			{
				path: "eeg-report",
				component: () =>
					import(
            /* webpackChunkName: "center-eeg-report" */ "../views/center/EEGReport.vue"
					),
			},
			{
				path: "payment",
				component: () =>
					import(
            /* webpackChunkName: "center-payment" */ "../views/center/Payment.vue"
					),
			},
			{
				path: "billing-xray",
				component: () =>
					import(
            /* webpackChunkName: "center-billing-xray" */ "../views/center/BillingXray.vue"
					),
			},
			{
				path: "billing-ecg",
				component: () =>
					import(
            /* webpackChunkName: "center-billing-ecg" */ "../views/center/BillingEcg.vue"
					),
			},
			{
				path: "billing-pft",
				component: () =>
					import(
            /* webpackChunkName: "center-billing-pft" */ "../views/center/BillingPFT.vue"
					),
			},
			{
				path: "billing-eeg",
				component: () =>
					import(
            /* webpackChunkName: "center-billing-eeg" */ "../views/center/BillingEeg.vue"
					),
			},
			{
				path: "general-settings",
				component: () =>
					import(
            /* webpackChunkName: "center-general-settings" */ "../views/center/GeneralSettings.vue"
					),
			},
				{
				path: "change-password",
				component: () =>
					import(
            /* webpackChunkName: "center-change-password" */ "../views/center/PasswordChange.vue"
					),
			},
			{
				path: "rate-chart",
				component: () =>
					import(
            /* webpackChunkName: "rate-chart" */ "../views/center/RateChart.vue"
					),
			},
			{
				path: "contact-admin",
				component: () =>
					import(
            /* webpackChunkName: "contact-admin" */ "../views/center/ContactAdmin.vue"
					),
			},
			{
				path: "prefer-radiologist",
				component: () =>
					import(
            /* webpackChunkName: "prefer-radiologist" */ "../views/center/PreferRadiologist.vue"
					),
			},
			{
				path: "prefer-cardiologist",
				component: () =>
					import(
            /* webpackChunkName: "prefer-cardiologist" */ "../views/center/PreferCardiologist.vue"
					),
			},
			{
				path: "prefer-pulmonologist",
				component: () =>
					import(
            /* webpackChunkName: "prefer-pulmonologist" */ "../views/center/PreferPulmonologist.vue"
					),
			},
			{
				path: "prefer-neurologist",
				component: () =>
					import(
            /* webpackChunkName: "prefer-neurologist" */ "../views/center/PreferNeurologist.vue"
					),
			},
		],
	},
	// radiologist
	{
		path: "/radiologist",
		component: () =>
			import(
        /* webpackChunkName: "radiologistHome" */ "../views/radiologist/RadiologistHome.vue"
			),
		redirect: "/radiologist/dashboard",
		children: [
			{
				path: "dashboard",
				component: () =>
					import(
            /* webpackChunkName: "radiologist-dashboard" */ "../views/radiologist/Dashboard.vue"
					),
			},
			{
				path: "reports/:page",
				component: () =>
					import(
            /* webpackChunkName: "radiologist-reports" */ "../views/radiologist/Reports.vue"
					),
			},
			{
				path: "change-password",
				component: () =>
					import(
            /* webpackChunkName: "radiologist-change-password" */ "../views/radiologist/PasswordChange.vue"
					),
			},
			{
				path: "report/:report_id",
				component: () =>
					import(
            /* webpackChunkName: "radiologist-report" */ "../views/radiologist/Report.vue"
					),
			},
			{
				path: "reporting/:report_id",
				component: () =>
					import(
            /* webpackChunkName: "radiologist-reporting" */ "../views/radiologist/Reporting.vue"
					),
			},
			{
				path: "print-xray-report/:reportId",
				component: () =>
					import(
            /* webpackChunkName: "radiologist-print-xray-report" */ "../views/radiologist/PrintXrayReport.vue"
					),
			},
			{
				path: "templates",
				component: () =>
					import(
            /* webpackChunkName: "radiologist-templates" */ "../views/radiologist/Templates.vue"
					),
			},
			{
				path: "billing",
				component: () =>
					import(
            /* webpackChunkName: "radiologist-billing" */ "../views/radiologist/Billing.vue"
					),
			},
			{
				path: "my-received",
				component: () =>
					import(
            /* webpackChunkName: "radiologist-my-received" */ "../views/radiologist/myReceived.vue"
					),
			},
		],
	},
	// cardiologist
	{
		path: "/cardiologist",
		component: () =>
			import(
        /* webpackChunkName: "cardiologistHome" */ "../views/cardiologist/CardiologistHome.vue"
			),
		redirect: "/cardiologist/dashboard",
		children: [
			{
				path: "dashboard",
				component: () =>
					import(
            /* webpackChunkName: "cardiologist-dashboard" */ "../views/cardiologist/Dashboard.vue"
					),
			},
			{
				path: "reports/:page",
				component: () =>
					import(
            /* webpackChunkName: "cardiologist-reports" */ "../views/cardiologist/Reports.vue"
					),
			},
			{
				path: "report/:report_id",
				component: () =>
					import(
            /* webpackChunkName: "cardiologist-report" */ "../views/cardiologist/Report.vue"
					),
			},
			{
				path: "print-ecg-report/:reportId",
				component: () =>
					import(
            /* webpackChunkName: "cardiologist-print-ecg-report" */ "../views/cardiologist/PrintECGReport.vue"
					),
			},
			{
				path: "templates",
				component: () =>
					import(
            /* webpackChunkName: "cardiologist-templates" */ "../views/cardiologist/Templates.vue"
					),
			},
			{
				path: "billing",
				component: () =>
					import(
            /* webpackChunkName: "cardiologist-billing" */ "../views/cardiologist/Billing.vue"
					),
			},
			{
				path: "my-received",
				component: () =>
					import(
            /* webpackChunkName: "cardiologist-my-received" */ "../views/cardiologist/myReceived.vue"
					),
			},
		],
	},
	// pulmonologist
	{
		path: "/pulmonologist",
		component: () =>
			import(
        /* webpackChunkName: "pulmonologistHome" */ "../views/pulmonologist/PulmonologistHome.vue"
			),
		redirect: "/pulmonologist/dashboard",
		children: [
			{
				path: "dashboard",
				component: () =>
					import(
            /* webpackChunkName: "pulmonologist-dashboard" */ "../views/pulmonologist/Dashboard.vue"
					),
			},
			{
				path: "reports/:page",
				component: () =>
					import(
            /* webpackChunkName: "pulmonologist-reports" */ "../views/pulmonologist/Reports.vue"
					),
			},
			{
				path: "report/:report_id",
				component: () =>
					import(
            /* webpackChunkName: "pulmonologist-report" */ "../views/pulmonologist/Report.vue"
					),
			},
			{
				path: "print-ecg-report/:reportId",
				component: () =>
					import(
            /* webpackChunkName: "pulmonologist-print-ecg-report" */ "../views/pulmonologist/PrintPFTReport.vue"
					),
			},
			{
				path: "templates",
				component: () =>
					import(
            /* webpackChunkName: "pulmonologist-templates" */ "../views/pulmonologist/Templates.vue"
					),
			},
			{
				path: "billing",
				component: () =>
					import(
            /* webpackChunkName: "pulmonologist-billing" */ "../views/pulmonologist/Billing.vue"
					),
			},
			{
				path: "my-received",
				component: () =>
					import(
            /* webpackChunkName: "pulmonologist-my-received" */ "../views/pulmonologist/myReceived.vue"
					),
			},
		],
	},
	// neurologist
	{
		path: "/neurologist",
		component: () =>
			import(
        /* webpackChunkName: "neurologistHome" */ "../views/neurologist/NeurologistHome.vue"
			),
		redirect: "/neurologist/dashboard",
		children: [
			{
				path: "dashboard",
				component: () =>
					import(
            /* webpackChunkName: "neurologist-dashboard" */ "../views/neurologist/Dashboard.vue"
					),
			},
			{
				path: "reports/:page",
				component: () =>
					import(
            /* webpackChunkName: "neurologist-reports" */ "../views/neurologist/Reports.vue"
					),
			},
			{
				path: "report/:report_id",
				component: () =>
					import(
            /* webpackChunkName: "neurologist-report" */ "../views/neurologist/Report.vue"
					),
			},
			{
				path: "templates",
				component: () =>
					import(
            /* webpackChunkName: "neurologist-templates" */ "../views/neurologist/Templates.vue"
					),
			},
			{
				path: "billing",
				component: () =>
					import(
            /* webpackChunkName: "neurologist-billing" */ "../views/neurologist/Billing.vue"
					),
			},
			{
				path: "my-received",
				component: () =>
					import(
            /* webpackChunkName: "neurologist-my-received" */ "../views/neurologist/myReceived.vue"
					),
			},
		],
	},
	// agent
	{
		path: "/agent",
		component: () =>
			import(
        /* webpackChunkName: "agentHome" */ "../views/agent/AgentHome.vue"
			),
		redirect: "/agent/dashboard",
		children: [
			{
				path: "dashboard",
				component: () =>
					import(
            /* webpackChunkName: "agent-dashboard" */ "../views/agent/Dashboard.vue"
					),
			},
			{
				path: "xray-reports",
				component: () =>
					import(
            /* webpackChunkName: "agent-xray-reports" */ "../views/agent/XrayReports.vue"
					),
			},
			{
				path: "ecg-reports",
				component: () =>
					import(
            /* webpackChunkName: "agent-ecg-reports" */ "../views/agent/EcgReports.vue"
					),
			},
			{
				path: "pft-reports",
				component: () =>
					import(
            /* webpackChunkName: "agent-pft-reports" */ "../views/agent/PFTReports.vue"
					),
			},
			{
				path: "eeg-reports",
				component: () =>
					import(
            /* webpackChunkName: "agent-eeg-reports" */ "../views/agent/EEGReports.vue"
					),
			},
			{
				path: "usg-reports",
				component: () =>
					import(
            /* webpackChunkName: "agent-usg-reports" */ "../views/agent/USGReports.vue"
					),
			},

			{
				path: "center-details",
				component: () =>
					import(
            /* webpackChunkName: "agent-center-details" */ "../views/agent/CenterDetails.vue"
					),
			},

			{
				path: "xray-uploading",
				component: () =>
					import(
            /* webpackChunkName: "agent-xray-uploading" */ "../views/agent/XRayUploading.vue"
					),
			},

			{
				path: "my-received",
				component: () =>
					import(
            /* webpackChunkName: "agent-my-received" */ "../views/agent/myReceived.vue"
					),
			},
		],
	},
	{
		path: "/app",
		component: () =>
			import(/* webpackChunkName: "appHome" */ "../views/app/AppHome.vue"),
		redirect: "/app/dashboard",
		children: [
			{
				path: "dashboard",
				component: () =>
					import(/* webpackChunkName: "app-dashboard" */ "../views/app/Dashboard.vue"),
			},
			{
				path: "xray-reporting",
				component: () =>
					import(/* webpackChunkName: "app-radiology-reporting" */ "../views/app/RadiologyReporting.vue"),
			},
			{
				path: "xray-reporting/bulk-download",
				component: () =>
					import(/* webpackChunkName: "app-radiology-bulk-download" */ "../views/app/RadiologyBulkDownload.vue"),
			},
			{
				path: "ecg-reporting",
				component: () =>
					import(/* webpackChunkName: "app-cardiology-reporting" */ "../views/app/CardiologyReporting.vue"),
			},
			{
				path: "ecg-reporting/bulk-download",
				component: () =>
					import(/* webpackChunkName: "app-radiology-bulk-download" */ "../views/app/RadiologyBulkDownload.vue"),
				props: {
					title: "Bulk ECG Download",
					subtitle: "Generate merged ECG reports for a selected date and time range",
					icon: "fa-solid fa-heart-pulse",
					returnRoute: "/app/ecg-reporting",
					loadEndpoint: "center/load-merged-ecg-reports",
					generateEndpoint: "center/generate-merged-ecg-report",
					downloadDirectory: "ecg_reports",
					showIncludeImages: false,
				},
			},
			{
				path: "pft-reporting",
				component: () =>
					import(/* webpackChunkName: "app-pulmonology-reporting" */ "../views/app/PulmonologyReporting.vue"),
			},
			{
				path: "eeg-reporting",
				component: () =>
					import(/* webpackChunkName: "app-neurology-reporting" */ "../views/app/NeurologyReporting.vue"),
			},
			{
				path: "usg-reporting",
				component: () =>
					import(/* webpackChunkName: "app-usg-reporting" */ "../views/app/USGReporting.vue"),
			},
			{
				path: "add-case",
				component: () =>
					import(/* webpackChunkName: "app-add-case" */ "../views/app/AddCase.vue"),
			},
			{
				path: "add-radiology-case",
				component: () =>
					import(/* webpackChunkName: "app-add-radiology-case" */ "../views/app/AddRadiologyCase.vue"),
			},
			{
				path: "edit-radiology-case/:id",
				component: () =>
					import(/* webpackChunkName: "app-add-radiology-case" */ "../views/app/AddRadiologyCase.vue"),
			},
			{
				path: "add-ecg-case",
				component: () =>
					import(/* webpackChunkName: "app-add-ecg-case" */ "../views/app/AddEcgCase.vue"),
			},
			{
				path: "edit-ecg-case/:id",
				component: () =>
					import(/* webpackChunkName: "app-add-ecg-case" */ "../views/app/AddEcgCase.vue"),
			},
			{
				path: "add-pft-case",
				component: () =>
					import(/* webpackChunkName: "app-add-pft-case" */ "../views/app/AddPftCase.vue"),
			},
			{
				path: "edit-pft-case/:id",
				component: () =>
					import(/* webpackChunkName: "app-add-pft-case" */ "../views/app/AddPftCase.vue"),
			},
			{
				path: "add-eeg-case",
				component: () =>
					import(/* webpackChunkName: "app-add-eeg-case" */ "../views/app/AddEegCase.vue"),
			},
			{
				path: "edit-eeg-case/:id",
				component: () =>
					import(/* webpackChunkName: "app-add-eeg-case" */ "../views/app/AddEegCase.vue"),
			},
			{
				path: "add-usg-case",
				component: () =>
					import(/* webpackChunkName: "app-add-usg-case" */ "../views/app/AddUsgCase.vue"),
			},
			{
				path: "edit-usg-case/:id",
				component: () =>
					import(/* webpackChunkName: "app-add-usg-case" */ "../views/app/AddUsgCase.vue"),
			},
			{
				path: "payment",
				component: () =>
					import(/* webpackChunkName: "app-payment" */ "../views/app/Payment.vue"),
			},
			{
				path: "xray-billing",
				component: () =>
					import(/* webpackChunkName: "app-xray-billing" */ "../views/app/XrayBilling.vue"),
			},
			{
				path: "ecg-billing",
				component: () =>
					import(/* webpackChunkName: "app-ecg-billing" */ "../views/app/EcgBilling.vue"),
			},
			{
				path: "pft-billing",
				component: () =>
					import(/* webpackChunkName: "app-pft-billing" */ "../views/app/PftBilling.vue"),
			},
			{
				path: "eeg-billing",
				component: () =>
					import(/* webpackChunkName: "app-eeg-billing" */ "../views/app/EegBilling.vue"),
			},
			{
				path: "usg-billing",
				component: () =>
					import(/* webpackChunkName: "app-usg-billing" */ "../views/app/UsgBilling.vue"),
			},
			{
				path: "general-settings",
				component: () =>
					import(/* webpackChunkName: "app-general-settings" */ "../views/app/GeneralSettings.vue"),
			},
			{
				path: "rate-chart",
				component: () =>
					import(/* webpackChunkName: "app-rate-chart" */ "../views/app/RateChart.vue"),
			},
			{
				path: "prefer-radiologist",
				component: () =>
					import(/* webpackChunkName: "app-prefer-radiologist" */ "../views/app/PreferredRadiologists.vue"),
			},
			{
				path: "prefer-cardiologist",
				component: () =>
					import(/* webpackChunkName: "app-prefer-cardiologist" */ "../views/app/PreferredCardiologists.vue"),
			},
			{
				path: "prefer-pulmonologist",
				component: () =>
					import(/* webpackChunkName: "app-prefer-pulmonologist" */ "../views/app/PreferredPulmonologists.vue"),
			},
			{
				path: "prefer-neurologist",
				component: () =>
					import(/* webpackChunkName: "app-prefer-neurologist" */ "../views/app/PreferredNeurologists.vue"),
			},
			{
				path: "usg-dr-signatures",
				component: () =>
					import(/* webpackChunkName: "app-usg-dr-signatures" */ "../views/app/USGDoctorSignatures.vue"),
			},
			{
				path: "contact-admin",
				component: () =>
					import(/* webpackChunkName: "app-contact-admin" */ "../views/app/ContactAdmin.vue"),
			},
			{
				path: "change-password",
				component: () =>
					import(/* webpackChunkName: "app-change-password" */ "../views/app/ChangePassword.vue"),
			},
			{
				path: "complain",
				component: () =>
					import(/* webpackChunkName: "app-complaint" */ "../views/app/Complaint.vue"),
			},
			{
				path: "support-tickets",
				component: () =>
					import(/* webpackChunkName: "app-support-tickets" */ "../views/app/SupportTickets.vue"),
			},
		],
	},
	{
		path: "/about",
		name: "About",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "aboutme" */ "../views/About.vue"),
	},
	{
		path: "/admin-login",
		component: () =>
			import(/* webpackChunkName: "adminLogin" */ "../views/AdminLogin.vue"),
	},
	{
		path: "/black-login",
		component: () =>
			import(/* webpackChunkName: "blackLogin" */ "../views/BlackLogin.vue"),
	},
	{
		path: "/login",
		component: () =>
			import(/* webpackChunkName: "blackLogin2" */ "../views/BlackLogin2.vue"),
	},
	{
		path: "/center-login",
		component: () =>
			import(/* webpackChunkName: "centerLogin" */ "../views/CenterLogin.vue"),
	},
	{
		path: "/radiologist-login",
		component: () =>
			import(
        /* webpackChunkName: "radiologistLogin" */ "../views/RadiologistLogin.vue"
			),
	},
	{
		path: "/cardiologist-login",
		component: () =>
			import(
        /* webpackChunkName: "cardiologistLogin" */ "../views/CardiologistLogin.vue"
			),
	},
	{
		path: "/pulmonologist-login",
		component: () =>
			import(
        /* webpackChunkName: "pulmonologistLogin" */ "../views/PulmonologistLogin.vue"
			),
	},
	{
		path: "/neurologist-login",
		component: () =>
			import(
        /* webpackChunkName: "neurologistLogin" */ "../views/NeurologistLogin.vue"
			),
	},
	{
		path: "/agent-login",
		component: () =>
			import(/* webpackChunkName: "agentLogin" */ "../views/AgentLogin.vue"),
	},
	{
		path: "/admin-change-password",
		component: () => import(/* webpackChunkName: "standalone-password-change" */ "../views/StandalonePasswordChange.vue"),
		props: { role: 'admin' },
	},
	{
		path: "/center-change-password",
		component: () => import(/* webpackChunkName: "standalone-password-change" */ "../views/StandalonePasswordChange.vue"),
		props: { role: 'center' },
	},
	{
		path: "/radiologist-change-password",
		component: () => import(/* webpackChunkName: "standalone-password-change" */ "../views/StandalonePasswordChange.vue"),
		props: { role: 'radiologist' },
	},
	{
		path: "/cardiologist-change-password",
		component: () => import(/* webpackChunkName: "standalone-password-change" */ "../views/StandalonePasswordChange.vue"),
		props: { role: 'cardiologist' },
	},
	{
		path: "/pulmonologist-change-password",
		component: () => import(/* webpackChunkName: "standalone-password-change" */ "../views/StandalonePasswordChange.vue"),
		props: { role: 'pulmonologist' },
	},
	{
		path: "/neurologist-change-password",
		component: () => import(/* webpackChunkName: "standalone-password-change" */ "../views/StandalonePasswordChange.vue"),
		props: { role: 'neurologist' },
	},
	{
		path: "/agent-change-password",
		component: () => import(/* webpackChunkName: "standalone-password-change" */ "../views/StandalonePasswordChange.vue"),
		props: { role: 'agent' },
	},
	{
		path: "/terms-conditions",
		component: () =>
			import(/* webpackChunkName: "termsConditions" */ "../views/Terms.vue"),
	},
	{
		path: "/refund-policy",
		component: () =>
			import(/* webpackChunkName: "refundPolicy" */ "../views/Refund.vue"),
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

function hasTrLiteSession() {
	try {
		const user = JSON.parse(localStorage.getItem("userdata") || "null");
		return Boolean(user?.email && user?.password && localStorage.getItem("centerid"));
	} catch (error) {
		return false;
	}
}

router.beforeEach((to, from) => {
	const normalizedPath = to.path.replace(/\/{2,}/g, "/");
	if (normalizedPath !== to.path) {
		return {
			path: normalizedPath,
			query: to.query,
			hash: to.hash,
			replace: true,
		};
	}

	const isMobileRoute = to.path === "/mobile" || to.path.startsWith("/mobile/");
	const isMobileLogin = to.path === "/mobile/login";
	const authenticated = hasTrLiteSession();

	if (isMobileRoute && !isMobileLogin && !authenticated) return "/mobile/login";
	if (isMobileLogin && authenticated) return "/mobile/dashboard";
	// Keep Teleradio isolated from the website root during authenticated navigation.
	if (from.path.startsWith("/mobile/") && to.path === "/" && authenticated) return "/mobile/dashboard";
	return true;
});

router.afterEach((to, from) => {
	if (typeof to.meta?.title === "string") {
		document.title = to.meta.title;
		return;
	}

	if (from.path === "/mobile" || from.path.startsWith("/mobile/")) {
		document.title = "TeleRadio";
	}
});

export default router;
